import { skills } from "../data/skills";

const Skills = () => {
  return (
    <section id="skills" className="mb-12">
      <h2 className="text-3xl font-bold mb-4">Skills</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {skills.map((skill) => (
          <div
            key={skill}
            className="bg-white rounded-lg shadow p-4 text-center transition-all hover:shadow-lg"
          >
            <span className="text-gray-800">{skill}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
